<template>
  <div>
  	<el-button type="primary" class="addBtn" @click="addBtnClick">添加分类</el-button>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		    <el-table-column
		      prop="sort"
		      label="权重"
		      align="center"
		      width="120"
        >
		    </el-table-column>
		    
        <el-table-column
          prop="article_class_name"
          label="分类名称"
          align="center"
        >
        </el-table-column>
		    <el-table-column
		      label="操作"
		      align="center"
		      width="150"
        >
         <template slot-scope="scope">
         	  <div class="operation-wrap">
         	    <span class="opration-item" @click="editCategoryClick(scope.row)">编辑</span>
         	    <span class="opration-item" @click="deleteCategoryClick(scope.row)">删除</span>
         	  </div>
         </template>
		    </el-table-column>
		  </el-table>
		  <common-pagination
			  :total="total"
        :page_size="page_size"
			  @size-change="handelPagesizeChange"
			  @page-change="handlePageChange"
			></common-pagination>
    </div>
    <common-dialog
    :title="dialogTitle"
    :dialogVisible="dialogVisible"
    @cancel="dialogCancelClick"
    @confirm="dialogConfirmClick"
    @dialog-close="dialogClose"
		>
      <div class="dialog-body-wrap">
  		  <div v-if="dialogType === 'delete'">
          是否删除分类？
        </div>
        <div v-if="dialogType === 'add' || dialogType ==='edit'" class="input-wrap-container">
  		  	<div class="input-wrap">
  		  		<label>分类名称</label>
  		  		<el-input v-model="handle_row.article_class_name" placeholder="请输入分类名称"></el-input>
  		  	</div>
  		  	<div class="input-wrap">
  		  		<label>权重</label>
  		  		<el-input v-model="handle_row.sort" placeholder="请输入权重"></el-input>
  		  	</div>
  		  </div>
      </div>
		</common-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import CommonDialog from '@/components/CommonDialog';
import CommonPagination from '@/components/CommonPagination';
import { getArticleClassList, addArticleClass, editArticleClass, deleteArticleClass } from '@/api/article-manage';

export default {
  name: 'casemanage',
  data() {
  	return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      dialogType: '',
      handle_row: {},
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  	}
  },
  computed: {
  	...mapState(['imgDomain'])
  },
  mounted() {
    this._getArticleClassList();
  },
  components: {
     CommonDialog,
     CommonPagination
  },
  methods: {
    async _getArticleClassList() {
      let postData = {
        page_index: this.page_index,
        page_size: this.page_size
      }
      const { data, status } = await getArticleClassList(postData);
      if (status !== 200 ) return
      this.tableData = data.data;
      this.total = data.total;
    },
  	addBtnClick() {
      this.dialogType = 'add';
      this.dialogTitle = '添加分类';
      this.dialogVisible = true;
  	},
  	dialogCancelClick() {
      this.dialogVisible = false;
  	},
  	async dialogConfirmClick() {
      let dialogType = this.dialogType;
      if (dialogType === 'edit' || dialogType === 'add') {
        const { sort, article_class_name } = this.handle_row;
        if (!article_class_name) {
          this.$message('分类名称不能为空');
          return
        }
        if (!sort) {
          this.$message('排序序号不能为空');
          return
        }
        if (+sort < 0 || +sort > 99 || sort%1 !== 0) {
          this.$message('排序序号必须为0～99之间的整数');
          return
        }
        if (dialogType === 'add') {
          const { status } = await addArticleClass(this.handle_row);
          if ( status === 200 ) this.dialogVisible = false
        } else if (dialogType === 'edit') {
          const { status } = await editArticleClass(this.handle_row);
          if ( status === 200 ) this.dialogVisible = false
        }
      } else if (dialogType === 'delete') {
        const { status } = await deleteArticleClass(this.handle_row.id);
        if ( status === 200 ) this.dialogVisible = false
      }
  	},
  	dialogClose() {
      this.dialogVisible = false;
      this._getArticleClassList();
      this.handle_row = {};
  	},
  	handelPagesizeChange(size) {
      this.page_size = size;
      this._getArticleClassList();
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this._getArticleClassList();
  	},
    deleteCategoryClick(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.dialogTitle = '删除公告';
      this.dialogType = 'delete';
      this.dialogVisible = true;
    },
    editCategoryClick(row) {
      this.handle_row = JSON.parse(JSON.stringify(row));
      this.dialogType = 'edit';
      this.dialogTitle = '编辑分类';
      this.dialogVisible = true;
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.addBtn {
	float: right;
	margin-bottom: 40px;
}
.table-wrap {
	margin-bottom: 40px;
}
.operation-wrap {
	display: flex;
	justify-content: space-around;
	color: @color-text;
	.opration-item{
		cursor: pointer;
	}
}
.dialog-body-wrap {
	text-align: center;
	.input-wrap-container {
		text-align: left;
		.input-wrap {
			margin-bottom: 30px;
		}
	}
}
</style>
